import { Navigate, Outlet } from "react-router-dom";

const AuthRoute = () => {
  const userDetailsString = localStorage.getItem("userDetails");

  let userDetails = null;
  try {
    userDetails = userDetailsString ? JSON.parse(userDetailsString) : null;
  } catch (error) {
    // console.error("Error parsing userDetails from localStorage:", error);
  }  

  return userDetails && Object.keys(userDetails).length > 0 ? (
      <Navigate to="/user/dashboard" />
    ) : (
      <Outlet />
  );
};

export default AuthRoute;